import { Controller, type Control } from 'react-hook-form';
import { TagPicker } from '@/features/tasks/public';
import type { Tag as ProjectTag } from '@/features/tags/public';
import type { QuickTaskDraftFormValues } from '../schemas';

interface TaskFieldTagsEditorProps {
  control: Control<QuickTaskDraftFormValues>;
  projectId: string;
  selectedTags: ProjectTag[];
  onTagsChange: (tags: ProjectTag[]) => void;
}

/**
 * The same picker the task detail uses: it creates a tag inline, so a proposed tag the project
 * lacks is one click away instead of a trip to project settings.
 */
export function TaskFieldTagsEditor({
  control,
  projectId,
  selectedTags,
  onTagsChange,
}: TaskFieldTagsEditorProps) {
  return (
    <Controller
      name="tags"
      control={control}
      render={({ field: tagsField }) => (
        <TagPicker
          projectId={projectId}
          selectedTags={selectedTags}
          onChange={(tags) => {
            onTagsChange(tags);
            // By id when the project has one, by name when the tag is still to be created:
            // dropping the id-less entries lost every new tag the proposal named the moment the
            // user touched the picker.
            tagsField.onChange(
              tags.map((tag) => tag.id ?? tag.name).filter((entry): entry is string => !!entry),
            );
          }}
        />
      )}
    />
  );
}
